module.exports = __webpack_public_path__ + "static/media/gm.414139d5.svg";